import React from "react";
import { styled } from '@mui/material/styles';
import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";

const PREFIX = 'textbox';

const classes = {
  formControl: `${PREFIX}-formControl`,
  selectEmpty: `${PREFIX}-selectEmpty`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.formControl}`]: {
    //   margin: theme.spacing(1),
    minWidth: 120,
    width: "98%",
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
  }
}));

export default function TextBox({
  field,
  label,
  value,
  placeholder,
  handleChange,
}) {


  const handleChange1 = (event) => {
    handleChange(field, event.target.value);
  };

  return (
    <Root>
      <FormControl variant="standard" className={classes.formControl}>
        <TextField
          variant="standard"
          type="text"
          value={value}
          label={label}
          id={label}
          onChange={handleChange1}
          placeholder={placeholder}
        />
      </FormControl>
    </Root>
  );
}
